import WizardController from './wizard.controller';
import './wizard.css';

const template = require<string>('./wizard.html');

const wizardComponent:ng.IComponentOptions = {
  bindings: {
    title: "<",             // optional; shows toolbar with title
    currentStepIndex: '=',  // index of current step. Intended to bind to md-selected attr of md-tabs
    stepsCount: '<',        // no of steps
    nextButtonName: '<',
    isNextPrevented: '<',   // prevent next from going to a next step
    onNext: '&',            // callback function executed on click on Next button
    stepValidation: '&',    // callback function that is supposed to return boolean. If true user can go to next step/finish
    onFinish: '&',          // callback function executed on click on Finish button
    onCancel: '&'           // callback function executed on click on Cancel button
  },
  transclude: true,
  controller: WizardController,
  template
};
export default wizardComponent;



/** WEBPACK FOOTER **
 ** ./app/common/components/wizard/wizard.component.ts
 **/